export default __webpack_public_path__ + "static/media/Group1796.8b8fdbcb.svg";